import RemoveButtonImpl from './remove-button.js';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';
import { noop } from 'mojito/utils';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Component to display remove button.
 *
 * @class RemoveButton
 * @memberof Mojito.Presentation.Components
 */

/**
 * RemoveButton prop types.
 *
 * @property {Function} [onClick = ()=>{}] - Callback on button click.
 * @property {string} [class] - Class name assigned to the root element.
 * @property {string} [testId] - Testing identifier rendered as data-testid on the button.
 *
 * @memberof Mojito.Presentation.Components.RemoveButton
 */
const propTypes = {
    onClick: PropTypes.func,
    class: PropTypes.string,
    testId: PropTypes.string,
};

const defaultProps = {
    onClick: noop,
};

export default UIView('RemoveButton', RemoveButtonImpl, propTypes, defaultProps);
